import { render, staticRenderFns } from "./Pensum.vue?vue&type=template&id=f478ac1c&scoped=true&"
import script from "./Pensum.vue?vue&type=script&lang=js&"
export * from "./Pensum.vue?vue&type=script&lang=js&"
import style0 from "./Pensum.vue?vue&type=style&index=0&id=f478ac1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f478ac1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VFlex,VLayout,VSimpleTable})
